import ImageLogo from './ImageLogo';

export default ImageLogo;
